/**
  * 智慧园区 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

 const index = {
    // 园区介绍
    index (params) {
		return axios.get('/home/smarkpark/index', {params,params})
	},
	// 场馆列表
	venuelist(params) {
		return axios.get('/home/smarkpark/venuelist', {params,params})
	},
	// 场馆详情
	venuedetail(params) {
		return axios.get('/home/smarkpark/venuedetail', {params,params})
	},
	// 票务信息
	ticketlist(params) {
		return axios.get('/home/smarkpark/ticketlist', {params,params})
	},
	// 附加服务(弃用)
	services(params) {
		return axios.get('/home/smarkpark/services', {params,params})
	},
	// 普通用户下单
	userorder(params) {
		return axios.post('/home/smarkpark/userorder', qs.stringify(params))
	},
	// 参观者列表
	visitorlist(params){
		return axios.get('/home/smarkpark/visitorlist', {params,params})
	},
	// 创建参观者
	visitorcreate(params){
		return axios.post('/home/smarkpark/visitorcreate', qs.stringify(params))
	},
	// 编辑参观者
    visitoredit(params){
		return axios.post('/home/smarkpark/visitoredit', qs.stringify(params))
	},
	// 删除参观者
	visitordel(params){
		return axios.post('/home/smarkpark/visitorremove', qs.stringify(params))
	},
	// 参观者详情
	visitordetail(params){
		return axios.get('/home/smarkpark/visitordetail', {params,params})
	},
	// 附加服务, 接待员, 配置信息, 用户次卡, 票种类 (不论票的种类，都用这个接口)
	setinfo(params){
		return axios.get('/home/smarkpark/setinfo', {params,params})
	},
	// 订单列表
	orderlist(params){
		return axios.get('/home/smarkpark/orderlist', {params,params})
	},
	// 订单详情
	orderdetail(params){
		return axios.get('/home/smarkpark/orderdetail', {params,params})
	},
	// 支付
	pay(params){
		return axios.post('/home/smarkpark/pay', qs.stringify(params))
	},
	// 团体下单
	teamorder(params){
		return axios.post('/home/smarkpark/teamorder', qs.stringify(params))
	},
	// 次卡列表
	timescardlist(params){
		return axios.get('/home/smarkpark/timescardlist', {params,params})
	},
	// 次卡生成订单
	timescardbuy(params){
		return axios.post('/home/smarkpark/timescardbuy', qs.stringify(params))
	},
	// 用户次卡列表
	usertimescardlist(params){
		return axios.get('/home/smarkpark/usertimescardlist', {params,params})
	},
	// 用户次卡列表
	usertimescarddetail(params){
		return axios.get('/home/smarkpark/timescardorderdetail', {params,params})
	},
	// 票类型
	tickettype(params){
		return axios.get('/home/smarkpark/tickettype', {params,params})
	},
	// 团队类型
	teamtype(params){
		return axios.get('/home/smarkpark/teamtype', {params,params})
	},
	applyInvoice(params){
		return axios.post('/home/smarkpark/orderinvoice', qs.stringify(params))
	},
 }
 
 // 导出接口
 export default index